import { render } from "./OrderCustomFieldsPage.vue?vue&type=template&id=7daa00d0"
import script from "./OrderCustomFieldsPage.vue?vue&type=script&lang=js"
export * from "./OrderCustomFieldsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__